import { render, staticRenderFns } from "./CompGrid2x1.vue?vue&type=template&id=17dde6f6"
import script from "./CompGrid2x1.vue?vue&type=script&lang=js"
export * from "./CompGrid2x1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports